import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import UseCaseSelector from './components/UseCaseSelector';
import UseCase from './components/UseCase';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import FinalCTA from './components/FinalCTA';
import { useCaseData } from './useCaseData';

function App() {
  const [activeCase, setActiveCase] = useState('answers');

  const handleSelectCase = (caseId) => {
    setActiveCase(caseId);
    // Smooth scroll to the use case section
    setTimeout(() => {
      const element = document.getElementById('usecase-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleBrowseClick = () => {
    const element = document.getElementById('selector');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleDemoClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      const offsetTop = contactSection.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      <Header onBrowseClick={handleBrowseClick} onDemoClick={handleDemoClick} />
      <Hero />
      <UseCaseSelector activeCase={activeCase} onSelectCase={handleSelectCase} />

      <div id="usecase-section">
        {Object.keys(useCaseData).map((key) => (
          <UseCase
            key={key}
            isActive={activeCase === key}
            icon={useCaseData[key].icon}
            title={useCaseData[key].title}
            subtitle={useCaseData[key].subtitle}
            cards={useCaseData[key].cards}
            metrics={useCaseData[key].metrics}
            metricsTitle={useCaseData[key].metricsTitle}
          />
        ))}
      </div>

      <Testimonials />
      <ContactForm />
      <FinalCTA />
    </div>
  );
}

export default App;
